import { render, staticRenderFns } from "./BiliUpList.vue?vue&type=template&id=21162f7c&scoped=true"
import script from "./BiliUpList.vue?vue&type=script&lang=js"
export * from "./BiliUpList.vue?vue&type=script&lang=js"
import style0 from "./BiliUpList.vue?vue&type=style&index=0&id=21162f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21162f7c",
  null
  
)

export default component.exports